import axios from 'axios'
import qs from 'qs'
import { paramsFilter } from '@/util/util'
axios.defaults.timeout = 30000

// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true

// HTTPrequest拦截
axios.interceptors.request.use(config => {

  if (config.method === 'get') {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }

  return config
}, error => {
  return Promise.reject(error)
})

// HTTPresponse拦截
axios.interceptors.response.use(res => {
  const status = Number(res.data.code) || 0

  if (status !== 0 || status == 400) {
    return Promise.reject(res.data.msg)
  }

  return res.data
}, error => {
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/plugins/http/axios.js